import field, { Style } from './field';

export default {
	field,
	style: Style,
	fileUpload: true
};

